export default "__VITE_ASSET__CSj6I_7O__"